import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { constants } from 'src/app/constants';
import { dataDictionary } from 'src/app/dataDictionary';
import { EditUserRegistrationComponent } from 'src/app/pages/edit-user-registration/edit-user-registration.component';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.css']
})
export class PersonalDataComponent implements OnInit {
  myform:FormGroup;
  titles:Array<any>=[];
  genders:Array<any>=[];
  marriageStatus:Array<any>=[];
  Caste:Array<any> = [];
  Medium:Array<any>=[];
  branchs:Array<any>=[];
  maxDate: any = moment().format('yyyy-MM-DD');
  @Input() editData:any={}
  @Input() parent:EditUserRegistrationComponent;
  changed:boolean=false;
  personalData:any={};
  roleId: string = localStorage.getItem('RoleId');
  subjects: any;
  years: any;
  droleId:number=1;
  constructor(private fb:FormBuilder,private CommonService:CommonService) {
    this.getAll()
   }

  ngOnInit(): void {
    this.myform= this.fb.group({
      Title:['',Validators.required],
      FirstName:['',Validators.required],
      LastName:['',Validators.required],
      dob:['',Validators.required],
      Gender:['',Validators.required],
      MartialStatus:['',Validators.required],
      idNumber:['',Validators.required],
      Aadhar_Number: ['', Validators.required],
      Caste: ['', Validators.required],
      SubCaste: ['', Validators.required],
      Medium:['',Validators.required],
      Branch:['',Validators.required],
      status:[''],
      SubjectId:[''],
      AreaId:[''],
      ParentRelationShip:[''],
      ParentMobileNumber:[''],
      ParentName:[''],
      YearOfRegistration:['']
    })
    this.parent.childs['UserProfileData']=this
     if(this.roleId=='2'){
       this.myform.controls['SubjectId'].setValidators(Validators.required);
       this.myform.controls['SubjectId'].updateValueAndValidity();
       this.myform.controls['AreaId'].setValidators(Validators.required);
       this.myform.controls['AreaId'].updateValueAndValidity();
     }
  }
  ngOnChanges(){
  if(Object.keys(this.editData).length&&!this.changed){
    this.changed=true;
    this.personalData=this.editData['Personal'].length&&this.editData['Personal'][0];
    this.dataTransform();
    // this.getBranch();
  }
  this.getBranch();
  }
  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner()
  }
  getAll(){
    this.activeSpinner();
  
    let title=this.CommonService.postCall('GetDictionaryByKey',{DictionaryCode:dataDictionary.Title});//title
    let gender=this.CommonService.postCall('GetDictionaryByKey',{DictionaryCode:dataDictionary.Gender});//getgender
    let marriageStatus=this.CommonService.postCall('GetDictionaryByKey',{DictionaryCode:dataDictionary.MaritalStatus});//GetMarriageStatus
    let Caste = this.CommonService.postCall('GetDictionaryByKey', { DictionaryCode: dataDictionary.Caste });//Caste
    let Medium=this.CommonService.postCall('GetDictionaryByKey',{DictionaryCode:dataDictionary.Medium});//Medium
    forkJoin([title,gender,marriageStatus,Caste,Medium]).subscribe((res)=>{
      this.deactivateSpinner();
      [this.titles,this.genders,this.marriageStatus,this.Caste,this.Medium]=[...res]
      // this.titles=res[0];this.registrationTitle=res[1];this.genders=res[2] "YYYY-MM-DD HH:mm:ss
    },err=>{
      console.log(err);
      this.deactivateSpinner()
    })
  }


   getBranch(){
    let payLoad={
      TENANT_CODE:this.personalData['TenantCode'],
      CREATEDBY:localStorage.getItem('UserId'),
      RoleId:localStorage.getItem('RoleId')
    }
    let apiUrl=constants['GetAdminCourses']||'GetAdminCourses'
    let uri = apiUrl+'/' + localStorage.getItem('UserId');
    let id = this.personalData['ROLEID'];
     let code = this.personalData['TenantCode'];
     //let code = 73926649;
    this.CommonService.getCall(uri + '/' + 1 + '/' + code).subscribe(
      (res:any)=>{
        this.branchs=res;
        console.log(this.branchs);
      }
    )
  //  this.CommonService.postCall('GetBranch',payLoad).subscribe(                                                 
    //  (res:any)=>{
//this.branchs=res;
     // }
   // )
   }
   arearChange(){
     let branch=this.myform.value['Branch'];
     if(branch||branch==''){
       alert("Please select Grade");
       return;
     }
     let are=this.myform.value['AreaId'];
     let payLoad={
      "TNT_CODE": localStorage.getItem('TenantCode'),
      "COURSE_ID":branch,
      "AREAID":are
      }
      this.activeSpinner();
      this.CommonService.postCall('GetSubjectsByCourseArea',payLoad).subscribe(res=>
        {
          this.subjects=res;
          this.deactivateSpinner();
        }
        ,err=>{
          this.deactivateSpinner();
        })
   }

  dataTransform(){
    let data=this.personalData;this.myform.markAllAsTouched;
   let controls=this.myform.controls;
   controls['dob'].setValue(moment(this.personalData.DOB).format('yyyy-MM-DD'))
   controls['FirstName'].setValue(data.FIRSTNAME);
   controls['LastName'].setValue(data.LASTNAME);
   controls['Gender'].setValue(data.GENDER);
   controls['Title'].setValue(data.TITLE);
   controls['MartialStatus'].setValue(data.MARTIALSTATUS);//STATUS
   controls['status'].setValue(data.STATUS?1:0);
   controls['Branch'].setValue(data['CourseId']);
   controls['idNumber'].setValue(data['RollNumber']);
   controls['Aadhar_Number'].setValue(data['Aadhar_Number']);
   controls['Caste'].setValue(data['Caste']);
   controls['SubCaste'].setValue(data['SubCaste']);
   controls['Medium'].setValue(data['Medium']);
   controls['YearOfRegistration'].setValue(data['YearOfRegistration']);
   controls['ParentName'].setValue(data['ParentName']);
   controls['ParentMobileNumber'].setValue(data['Parent_Mobile_Number']);
   controls['ParentRelationShip'].setValue(data['ParentRelationShip']);
   this.droleId=data['ROLEID'];
   if(this.droleId==3){
     this.getYear();
     controls['YearOfRegistration'].setValidators(Validators.required);
     controls['YearOfRegistration'].updateValueAndValidity();
     controls['ParentName'].setValidators(Validators.required);
     controls['ParentName'].updateValueAndValidity();
     controls['ParentMobileNumber'].setValidators(Validators.required);
     controls['ParentMobileNumber'].updateValueAndValidity();
     controls['ParentRelationShip'].setValidators(Validators.required);
     controls['ParentRelationShip'].updateValueAndValidity();
   }
  //  Object.keys(controls).map(key=>{
  //    controls[key].markAsTouched();
  //  })
  // this.setIds();
  }
  getYear() {
    this.activeSpinner()
    let payload={
     

     }
     this.CommonService.postCall('Loadyear',payload).subscribe((res:any)=>{
      this.years=res;
      this.deactivateSpinner();
    },e=>this.deactivateSpinner());
  }
}
